import { render, staticRenderFns } from "./SopBlockDetailDrawio.vue?vue&type=template&id=78e1e8bd&scoped=true&"
import script from "./SopBlockDetailDrawio.vue?vue&type=script&lang=ts&"
export * from "./SopBlockDetailDrawio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e1e8bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
